"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { id: "slot-modal-roles" };
const _hoisted_2 = {
    key: 0,
    class: "accordion"
};
const _hoisted_3 = { class: "header-left d-flex" };
const _hoisted_4 = { for: "accordion-roles" };
const _hoisted_5 = { class: "header-right d-flex" };
const _hoisted_6 = {
    key: 0,
    class: "loading"
};
const _hoisted_7 = {
    key: 1,
    class: "accordion-body role-accordion-body"
};
const _hoisted_8 = ["data-tooltip", "onClick", "id", "title"];
const _hoisted_9 = {
    key: 0,
    class: "svg-container"
};
const _hoisted_10 = { class: "role-name-container" };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { class: "empty centered" };
const _hoisted_13 = { class: "empty-subtitle" };
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const GroupRoleIcon_vue_1 = __importDefault(require("../../vue/icons/GroupRoleIcon.vue"));
const models_1 = require("../../js/models");
const summary_lib_1 = require("../../js/summary_lib");
const injectionKeys_1 = require("../types/injectionKeys");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SlotModalRolesList',
    setup(__props) {
        // This component is currently rendered inside SlotModal
        const { t } = (0, vue_i18n_1.useI18n)();
        const injectedProps = (0, vue_3.inject)(injectionKeys_1.SlotModalRoleListInjectionKey);
        const { updateCurrentDate, currentDateTimestampSec } = (0, vue_3.inject)("currentDate", {
            updateCurrentDate: (dateTimestamp) => { },
            currentDateTimestampSec: (0, vue_3.ref)(0),
        });
        const roleSearchBarClass = (0, vue_3.computed)(() => {
            return {
                "form-input": true,
                "d-none": !isRoleSearchOpen.value,
            };
        });
        const roleSearchBtnClass = (0, vue_3.computed)(() => {
            return {
                "btn": true,
                "active": isRoleSearchOpen.value,
            };
        });
        const accClass = (0, vue_3.computed)(() => {
            return {
                "accordion-role-header-container": true,
                "search-active": isRoleSearchOpen.value,
            };
        });
        const roleSearch = (0, vue_3.ref)("");
        const isRoleSearchOpen = (0, vue_3.ref)(false);
        const rolesList = (0, vue_3.computed)(() => {
            if (!injectedProps?.value.rolesList) {
                return [];
            }
            return injectedProps.value.rolesList.filter(r => {
                if (injectedProps?.value.filterHiddenRoles) {
                    return !r.isHiddenInShiftPage;
                }
                return r;
            });
        });
        const rolesListForTemplate = (0, vue_3.computed)(() => {
            const text = roleSearch.value;
            if (!isRoleSearchOpen.value || !text) {
                return rolesList.value;
            }
            return rolesList.value.filter(r => r.getName().includes(text));
        });
        function roleBtnClass(role) {
            const isNonWorkingRole = role.slotType === 2 || role.slotType === 6 || role.slotType === 7;
            const isDisabled = isRoleSelectDisabled(role.getOriginalId());
            return {
                "slot-type-non-working": isNonWorkingRole,
                "select-disabled": isDisabled,
                "tooltip": isDisabled,
            };
        }
        function roleColor(role) {
            if (!role || !role.color || role.color === models_1.OPLUS_COLOR_PALETTE.DEFAULT) {
                return;
            }
            const style = {
                backgroundColor: `#${role.color}`,
                color: "#fff"
            };
            return style;
        }
        function handleRoleSelect(role) {
            if (isRoleSelectDisabled(role.getOriginalId())) {
                return;
            }
            emitRoleId(role.getId());
        }
        function emitRoleId(roleId) {
            (0, summary_lib_1.setRoleIdToSlotModal)(roleId);
            return;
        }
        function isRoleSelectDisabled(roleId) {
            return !(injectedProps?.value.roleDates?.[roleId]?.[currentDateTimestampSec.value]?.ShouldShow ?? true);
        }
        function handleRoleSearchClick() {
            isRoleSearchOpen.value = !isRoleSearchOpen.value;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("div", { class: "divider slot-modal-divider" }, null, -1 /* CACHED */)),
                (rolesList.value.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                        _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("input", {
                            type: "checkbox",
                            id: "accordion-roles",
                            name: "accordion-checkbox",
                            hidden: "",
                            checked: ""
                        }, null, -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("div", {
                            class: (0, vue_2.normalizeClass)(accClass.value),
                            id: "accordion-role-header-container"
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("label", _hoisted_4, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('slot_modal.roles_label', { count: rolesList.value.length })) + " ", 1 /* TEXT */),
                                    _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }, null, -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    id: "role-search-bar",
                                    type: "text",
                                    class: (0, vue_2.normalizeClass)(roleSearchBarClass.value),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((roleSearch).value = $event))
                                }, null, 2 /* CLASS */), [
                                    [vue_2.vModelText, roleSearch.value]
                                ]),
                                (0, vue_2.createElementVNode)("button", {
                                    id: "role-search-btn",
                                    class: (0, vue_2.normalizeClass)(roleSearchBtnClass.value),
                                    onClick: handleRoleSearchClick
                                }, [...(_cache[2] || (_cache[2] = [
                                        (0, vue_2.createElementVNode)("i", { class: "icon icon-search" }, null, -1 /* CACHED */)
                                    ]))], 2 /* CLASS */)
                            ])
                        ], 2 /* CLASS */),
                        ((0, vue_2.unref)(injectedProps)?.isLoading)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(rolesListForTemplate.value, (role) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        class: (0, vue_2.normalizeClass)(["btn chip slot-modal-role-btn slot-modal-role", roleBtnClass(role)]),
                                        "data-tooltip": (0, vue_2.unref)(t)('shift.add_disabled_tooltip'),
                                        onClick: ($event) => (handleRoleSelect(role)),
                                        key: role.getId(),
                                        id: `slot-modal-role-${role.getId()}`,
                                        style: (0, vue_2.normalizeStyle)(roleColor(role)),
                                        title: role.getName()
                                    }, [
                                        (role.isGroupRole)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, [
                                                (0, vue_2.createVNode)(GroupRoleIcon_vue_1.default)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("v-if", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)(role.getName()), 1 /* TEXT */)
                                    ], 14 /* CLASS, STYLE, PROPS */, _hoisted_8));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("p", { class: "empty-title h5" }, null, -1 /* CACHED */)),
                            (0, vue_2.createElementVNode)("p", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('slot_modal.no_roles')), 1 /* TEXT */)
                        ])
                    ]))
            ]));
        };
    }
});
